/***
import { SettingDrawerComponent } from './setting-drawer.component';
 * @FileName:
 * @Author: manyao.zhu
 * @Date: 2019-10-16 14:09:06
 * @file:
 * @author: manyao.zhu
 */
/**
 * å­å¨çé®
 */
// æ´ä½é£æ ¼
export const STYLE_KEY = 'style';
// ä¸»é¢è²
export const COLOR_KEY = 'color';
// å¯¼èªæ¨¡å¼
export const NAV_MODE_KEY = 'topMenu';
// åå®¹å®½åº¦
export const CONTENT_WIDTH_KEY = 'fixWidth';
// åºå®å¤´é¨
export const FIX_HEADER_KEY = 'fixHeader';
// éèå¤´é¨
export const HIDE_HEADER_KEY = 'hideHeader';
// // åºå®æçæ¶è
// export const FIX_COLLECTION_KEY = "fixCollection";
// // éèæçæ¶è
// export const HIDE_COLLECTION_KEY = "hideCollection";

// ** æ¯å¦æå èå æ­¤ä¸º header.component.tséå­å¨çï¼æåå°è¿ç»ä¸æ§å¶**
export const COLLAPSED_KEY = 'collapsed';

/**
 * æ°æ®éç½®
 */
export const STYLES = [
  {
    key: 'dark',
    img: 'https://gw.alipayobjects.com/zos/rmsportal/JopDzEhOqwOjeNTXkoje.svg',
    title: 'settingDrawer.styles.darkStyle',
    className: 'skin-dark',
  },
  {
    key: 'light',
    img: 'https://gw.alipayobjects.com/zos/rmsportal/jpRkZQMyYRryryPNtyIC.svg',
    title: 'settingDrawer.styles.brightStyle',
    className: 'skin-light',
  },
];
export const COLORS = [
  {
    key: 'daybreak',
    title: 'settingDrawer.colors.blue',
    color: '#1890ff',
    className: 'theme-daybreak',
  },
  {
    key: 'dust',
    title: 'settingDrawer.colors.red',
    color: '#F5222D',
    className: 'theme-dust',
  },
  {
    key: 'volcano',
    title: 'settingDrawer.colors.volcano',
    color: '#FA541C',
    className: 'theme-volcano',
  },
  {
    key: 'sunset',
    title: 'settingDrawer.colors.croci',
    color: '#FFA500',
    className: 'theme-sunset',
  },
  {
    key: 'cyan',
    title: 'settingDrawer.colors.cyan',
    color: '#13C2C2',
    className: 'theme-cyan',
  },
  {
    key: 'green',
    title: 'settingDrawer.colors.green',
    color: '#52C41A',
    className: 'theme-green',
  },

  {
    key: 'geekblue',
    title: 'settingDrawer.colors.geekblue',
    color: '#2F54EB',
    className: 'theme-geekblue',
  },
  {
    key: 'purple',
    title: 'settingDrawer.colors.purple',
    color: '#722ED1',
    className: 'theme-purple',
  },
];
export const NAV_MODES = [
  {
    img: 'https://gw.alipayobjects.com/zos/rmsportal/JopDzEhOqwOjeNTXkoje.svg',
    top: false,
    title: 'settingDrawer.navModes.slidMenu',
  },
  {
    img: 'https://gw.alipayobjects.com/zos/rmsportal/KDNDBbriJhLwuqMoxcAr.svg',
    top: true,
    title: 'settingDrawer.navModes.topMenu',
  },
];
export const CONTENT_WIDTHS = [
  {
    fixed: false,
    title: 'settingDrawer.contentWidths.streaming',
  },
  {
    fixed: true,
    title: 'settingDrawer.contentWidths.fixedWidth',
  },
];

/**
 * é»è®¤å¼
 */
export const DEFAULT_STYLE = STYLES[0];
export const DEFAULT_COLOR = COLORS[0];
export const DEFAULT_NAV_MODE = NAV_MODES[0].top;
export const DEFAULT_CONTENT_WIDTH = CONTENT_WIDTHS[0].fixed;
export const DEFAULT_FIX_HEADER = false;
export const DEFAULT_HIDE_HEADER = false;
// export const DEFAULT_FIX_COLLECTION = false;
// export const DEFAULT_HIDE_COLLECTION = false;
